export const GALERIA_LOADING = 'GALERIA_LOADING';
export const GALERIA_LOADED = 'GALERIA_LOADED';
export const GALERIA_ERROR = 'GALERIA_ERROR';

export const CREARGALERIA_ERROR = 'CREARGALERIA_ERROR';
export const CREARGALERIA_LOADED = 'CREARGALERIA_LOADED';
export const CREARGALERIA_LOADING = 'CREARGALERIA_LOADING';

export const EDITARGALERIA_ERROR = 'EDITARGALERIA_ERROR';
export const EDITARGALERIA_LOADED = 'EDITARGALERIA_LOADED';
export const EDITARGALERIA_LOADING = 'EDITARGALERIA_LOADING';

export const DELETEGALERIA_ERROR = 'DELETEGALERIA_ERROR';
export const DELETEGALERIA_LOADED = 'DELETEGALERIA_LOADED';
export const DELETEGALERIA_LOADING = 'DELETEGALERIA_LOADING';

export const USER_GALERIA_GET_LOADING = 'USER_GALERIA_GET_LOADING';
export const USER_GALERIA_GET_LOADED = 'USER_GALERIA_GET_LOADED';
export const USER_GALERIA_GET_ERROR = 'USER_GALERIA_GET_ERROR';